export function scrollPagination()
{
	let paginationButtons = document.querySelectorAll('.pagination__item');
	// console.log(paginationButtons);
	paginationButtons.forEach(element => {
		element.addEventListener("click", function (e) {
			// console.log(element);
			if (e) {
				let filterForm = document.querySelector('.containerWrapper');
				if (filterForm) {
					window.scrollTo({
					    top: filterForm.offsetTop,
					    behavior: 'smooth'
					});
				}
			}
		});
	});

}